// Product category pill - softened tint with a leading colored dot (design:
// billing Bx catalog). Known catalog categories get a fixed hue; anything
// else (categories are an open set in the database) falls back to gray.

import { Tooltip } from '@odo/shared-ui';

const CAT_TONE: Record<string, { chip: string; dot: string }> = {
    Treatment: { chip: 'bg-indigo-50 text-indigo-700', dot: 'bg-indigo-500' },
    Select: { chip: 'bg-teal-50 text-teal-700', dot: 'bg-teal-500' },
    Diagnostic: { chip: 'bg-rose-50 text-rose-700', dot: 'bg-rose-500' },
    Ancillary: { chip: 'bg-pink-50 text-pink-700', dot: 'bg-pink-500' },
    Retention: { chip: 'bg-violet-50 text-violet-700', dot: 'bg-violet-500' }
};

const FALLBACK_TONE = { chip: 'bg-gray-100 text-gray-600', dot: 'bg-gray-400' };

export function CategoryChip({ category }: { category: string | null }) {
    if (!category) return <span className="text-gray-300">-</span>;
    const tone = CAT_TONE[category] ?? FALLBACK_TONE;
    return (
        <span
            className={`inline-flex items-center max-w-[130px] gap-1.5 rounded-full px-2 py-0.5 text-[11px] font-semibold ${tone.chip}`}
        >
            <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${tone.dot}`} />
            <Tooltip content={category}>
                <span className="truncate">{category}</span>
            </Tooltip>
        </span>
    );
}
